import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchCinemas } from "@/lib/api";
import { useLocale } from "@/lib/locale";
import { Ticket, Star, Clapperboard } from "lucide-react";

export default function NowInCinemas() {
  const { country, t } = useLocale();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCinemas(country)
      .then((d) => setItems(d.results || []))
      .finally(() => setLoading(false));
  }, [country]);

  if (loading || items.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-6 pb-16" data-testid="now-in-cinemas">
      <div className="flex items-end justify-between mb-6">
        <div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-amber font-heading mb-2 flex items-center gap-1.5">
            <Clapperboard className="h-3 w-3" /> {t("in_cinemas")}
          </div>
          <h2 className="font-display text-3xl sm:text-4xl text-white">{t("in_cinemas_sub")}</h2>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 stagger">
        {items.slice(0, 12).map((m) => (
          <div
            key={m.id}
            className="group relative rounded-md overflow-hidden border border-white/8 bg-obsidian-surface hover:border-amber/40 transition"
            data-testid={`cinema-card-${m.id}`}
          >
            <Link to={`/title/${m.id}`} className="block">
              <div className="aspect-[2/3] overflow-hidden">
                <img
                  src={m.poster || "https://images.unsplash.com/photo-1616530940355-351fabd9524b"}
                  alt={m.title}
                  className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-3">
                <h3 className="font-display text-base text-white line-clamp-2">{m.title}</h3>
                <div className="mt-1 flex items-center gap-1.5 text-xs text-zinc-500 font-heading">
                  <span>{m.year}</span>
                  {m.rating ? <span className="inline-flex items-center gap-0.5 text-amber"><Star className="h-3 w-3 fill-amber" /> {m.rating}</span> : null}
                </div>
              </div>
            </Link>
            <a
              href={m.tickets_url}
              target="_blank"
              rel="noopener noreferrer"
              className="absolute bottom-3 right-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[10px] uppercase tracking-wider bg-amber text-obsidian font-heading shadow-[0_8px_30px_-10px_rgba(245,166,35,0.55)] hover:bg-amber-hover transition"
              data-testid={`buy-tickets-${m.id}`}
            >
              <Ticket className="h-3 w-3" /> {t("buy_tickets")}
            </a>
          </div>
        ))}
      </div>
    </section>
  );
}
